<template>
  <div>
    <section class="hero page-rules">
      <div class="hero-body">
        <div class="container page-header">
          <div class="columns">
            <div class="column is-one-third">
              <h1 class="title" style="color: #000"><span class="icon is-large"><i class="fa fa-exclamation-triangle"></i></span>Rules</h1>
              <h2 class="subtitle">
                Community guidelines and room rules. Avoid the banhammer.
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title" style="color: #000"><span class="icon is-large"><i class="fa fa-check" style="color: #00d1b2"></i></span>We feature <strong>electronic based</strong> chillout music:</h1>
          <div class="box">
            <ul>
              <li>Atmospheric DnB</li>
              <li>Ambient</li>
              <li>Acid Jazz</li>
              <li>Chillhop</li>
              <li>Chillout Electronica</li>
              <li>Chillwave</li>
              <li>Chillstep</li>
              <li>Chillout Trance</li>
              <li>Deep House</li>
              <li>Downtempo</li>
              <li>Dub</li>
              <li>Funk</li>
              <li>Future Garage</li>
              <li>Indian Chill</li>
              <li>Instrumental</li>
              <li>Jazzy Lounge</li>
              <li>Lofi</li>
              <li>Lounge</li>
              <li>Liquid DnB</li>
              <li>Microhouse</li>
              <li>Nu-Jazz</li>
              <li>Melodic Progressive</li>
              <li>Psychill</li>
              <li>Psybient</li>
              <li>Space Music</li>
              <li>Trip Hop</li>
              <li>Tribal Fusion</li>
              <li>Vaporwave</li>
            </ul>
          </div>
          <div class="content">
            <blockquote>
              <ul>
                <li>We feature beat-focused rather than vocal-focused music. Tracks containing prolonged vocals are subject to evaluation and may be skipped.</li>
                <li>Check room history before playing. Over-played tracks will be skipped.</li>
                <li>Search play history with the bot command: <span>!plays author - title</span></li>
                <li>Keep all tracks under 8 minutes. 10 minutes if the waitlist is 5 or below.</li>
              </ul>
            </blockquote>
          </div>
          <h1 class="title" style="color: #000"><span class="icon is-large"><i class="fa fa-times" style="color: red"></i></span>We do <strong>not</strong> play:</h1>
          <div class="box">
            <ul>
              <li>Acoustic</li>
              <li>Anime</li>
              <li>Alternative Pop</li>
              <li>Blues</li>
              <li>Big Room</li>
              <li>Brostep</li>
              <li>Classical</li>
              <li>Country</li>
              <li>Drumstep</li>
              <li>Dubstep</li>
              <li>Electro House</li>
              <li>Folk</li>
              <li>Indie</li>
              <li>Indie Pop</li>
              <li>Indie Rock</li>
              <li>Glitch-Hop</li>
              <li>Goa Trance</li>
              <li>Hardstyle</li>
              <li>Hip-Hop</li>
              <li>K-Pop</li>
              <li>J-Pop</li>
              <li>Jersey Club</li>
              <li>Mainstream EDM</li>
              <li>Metal</li>
              <li>Nightcore</li>
              <li>Orchestral</li>
              <li>Piano</li>
              <li>Pop</li>
              <li>Pop House</li>
              <li>Post Rock</li>
              <li>Punk</li>
              <li>Rap</li>
              <li>R&amp;B</li>
              <li>Rock</li>
              <li>Reggae</li>
              <li>Shoegaze</li>
              <li>Synthpop</li>
              <li>Tropical House</li>
              <li>Witch House</li>
              <li>Video Game Music</li>
            </ul>
          </div>
          <h1 class="title" style="color: #000"><span class="icon is-large"><i class="fa fa-legal" style="color: orange"></i></span>User Guidelines:</h1>
          <div class="content">
            <blockquote class="user-guidelines">
              <h1 class="title is-4" style="color: #000"><span class="icon is-medium"><i class="fa fa-list"></i></span>&nbsp;Chat:</h1>
              <ul>
                <li>We use the following Plug.dj plugins: <a href="https://rcs.radiant.dj/" target="_blank">RCS</a>.</li>
                <li>Producers and promoters may self-advertise with SoundCloud or YouTube links. </li>
                <li>We love to party; however, we permanent ban trolls, spammers, and those who disrespect the DJs, listeners and staff.</li>
                <li>Stay active in chat. Send us some funny and interesting images or hit some bot triggers!</li>
                <li>For unban, unmute or waitlist unblock: Please contact us on Discord or message the room host.</li>
              </ul>
              <h1 class="title is-4" style="color: #000"><span class="icon is-medium"><i class="fa fa-music"></i></span>&nbsp;DJ:</h1>
              <ul>
                <li>Please listen to a few songs before you DJ, so you get an idea of the room vibe.</li>
                <li>When in doubt, you can ask a moderator to preview a track by posting a YouTube or SoundCloud link.</li>
                <li>Staff or the Bot will skip off-genre and off-theme plays.</li>
                <li>Producers are encouraged to play their own songs, but please do not be obsessive and overplay them.</li>
                <li>We encourage flow in order to keep the mood of the room steady.</li>
                <li>For unban, unmute or waitlist unblock: Please contact us on Discord or message any of the room mods.</li>
              </ul>
              <h1 class="title is-4" style="color: #000"><span class="icon is-medium"><i class="fa fa-angle-double-up"></i></span>&nbsp;How to become a moderator:</h1>
              <ul>
                <li>We are always on the look-out for helpful and active users that have the best interest in our community.</li>
                <li>You should know the genres that we have listed above.</li>
                <li>You play awesome music consistently for weeks or months.</li>
                <li>You are a friendly, chatty, mature, and active user.</li>
                <li>We will approach you, not the other way around!</li>
              </ul>
              <h1 class="title is-4" style="color: #000"><span class="icon is-medium"><i class="fa fa-pencil-square-o"></i></span>&nbsp;Staff guidelines:</h1>
              <ul>
                <li>Treat others as you would like to be treated. Be patient and be nice in chat.</li>
                <li>Do not skip any songs based on personal preference. </li>
                <li>Inactive (30+ days) staff members will be removed from their position. They will be notified on Discord.</li>
                <li>Staff members are expected to be present and active in chat while on the wait list.</li>
                <li>Failure to follow the rules will result in a internal discussion about your removal.</li>
                <li>The weight of your words is dependent on the validity of the point you are making.</li>
              </ul>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Rules'
}
</script>

<style scoped>
.page-rules {
  background-image: linear-gradient( 135deg, #FDEB71 0%, #f8aa00 100%);
}

.box li {
  display: inline;
  background-color: #f5f5f5;
  padding: 2px 5px 2px 5px;
  margin-right: 5px;
  line-height: 2.2rem;
}

.content ul {
  margin-top: 0;
}

.user-guidelines {
  background-color: #fefefe;
}
</style>



// WEBPACK FOOTER //
// Rules.vue?c1f76852